import { useAuthStore } from '../store/authStore';

export interface Permission {
  obj: string;
  act: string;
}

/**
 * Check whether the current user has a specific permission.
 *
 * Usage:
 * ```ts
 * const { can, canEditRoles } = usePermissions();
 * ```
 *
 * This is a **UI-only** gate — the backend is the sole security boundary.
 */
export function usePermissions() {
  const permissions = useAuthStore((state) => state.permissions);
  const canEditRoles = useAuthStore((state) => state.companyCanEditRoles);

  const can = (obj: string, act: string): boolean => {
    if (!permissions || permissions.length === 0) return false;
    return permissions.some((p) => p.obj === obj && p.act === act);
  };

  return { can, permissions, canEditRoles };
}
